/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractInsuredAddress } from './ContractInsuredAddress';
import {
    ContractInsuredAddressFromJSON,
    ContractInsuredAddressFromJSONTyped,
    ContractInsuredAddressToJSON,
    ContractInsuredAddressToJSONTyped,
} from './ContractInsuredAddress';

/**
 * 
 * @export
 * @interface ContractInsured
 */
export interface ContractInsured {
    /**
     * Unique identifier of the person (natural or legal)
     * @type {string}
     * @memberof ContractInsured
     */
    id: string | null;
    /**
     * Display name of the subscriber (full name for natural persons, company name for legal entities)
     * @type {string}
     * @memberof ContractInsured
     */
    displayName: string;
    /**
     * Email address of the subscriber
     * @type {string}
     * @memberof ContractInsured
     */
    email: string;
    /**
     * 
     * @type {ContractInsuredAddress}
     * @memberof ContractInsured
     */
    address?: ContractInsuredAddress | null;
}

/**
 * Check if a given object implements the ContractInsured interface.
 */
export function instanceOfContractInsured(value: object): value is ContractInsured {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ContractInsuredFromJSON(json: any): ContractInsured {
    return ContractInsuredFromJSONTyped(json, false);
}

export function ContractInsuredFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractInsured {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'email': json['email'],
        'address': json['address'] == null ? undefined : ContractInsuredAddressFromJSON(json['address']),
    };
}

export function ContractInsuredToJSON(json: any): ContractInsured {
    return ContractInsuredToJSONTyped(json, false);
}

export function ContractInsuredToJSONTyped(value?: ContractInsured | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'email': value['email'],
        'address': ContractInsuredAddressToJSON(value['address']),
    };
}

